import { useFeatureFlags } from '@/app/modules/feature-flags';
import type { Guard } from './interfaces';

export function createFeatureFlagGuard(feature: string, redirect = '/'): Guard {
  return () => useFeatureFlags()?.isEnabled(feature) || redirect;
}
